import styled from '@emotion/styled'

import media from '../../../../styles/media'
import { colors, fonts } from '../../../../styles/theme'
import '../../../../../fonts/lato/index.css'

const S = {}

S.Header = styled.header`
  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    z-index: 1060;
    background: ${({ lightMode }) => (lightMode ? colors.white : colors.shark)};
    font-family: ${({ lightMode }) => (lightMode ? fonts.legacy : fonts.menu)};
    display: ${({ isMinimal }) => isMinimal && 'flex'};
    justify-content: ${({ isMinimal }) => isMinimal && 'center'};
    line-height: ${({ isMinimal }) => isMinimal && '0'};

    a {
      &:focus {
        outline: 0.125rem solid transparent;
        outline-offset: 0.125rem;
        box-shadow: 0 0 0 0.25rem rgba(160, 160, 160, 0.75) inset;
      }

      &:active {
        box-shadow: none;
      }
    }
  }

  .header-placeholder {
    height: ${({ hasSubNav }) => !hasSubNav && '3.75rem'};
  }

  .content {
    display: flex;
    height: 3.75rem;

    > * {
      line-height: 0;
    }
  }

  .menu-left {
    display: flex;

    ${media.sm`
      flex: 1 1 0%;
    `};
  }

  .menu-right {
    display: flex;
    justify-content: flex-end;
    flex: 1 1 0%;
  }

  .header-svg {
    padding: 1.125rem;

    path {
      fill: ${({ isMinimal }) => isMinimal && 'currentColor'};
      color: ${({ isMinimal }) => isMinimal && colors.orange};
    }
  }
`

export default S
